-- | GENERATED by tools/sync-por-para.mjs - do not edit.
-- |
-- | Source: data/es-por-para.csv (30 sentences).
module Flashcards.Data.PorPara.Spanish
  ( sentences
  )
  where

import Flashcards.Verbs.PorPara (Item(..), Preposition(..), Sentence)

-- | In the bank's order, which is the order their items are first asked
-- | in, and the order each item's pool is turned.
sentences :: Array Sentence
sentences =
  [ { before: "lo hice ", answer: Por, after: " ti"
    , english: "I did it because of you.", item: CausePurpose
    }
  , { before: "estudio ", answer: Para, after: " aprender"
    , english: "I study in order to learn.", item: CausePurpose
    }
  , { before: "lo hice ", answer: Para, after: " ti"
    , english: "I did it for your benefit.", item: CausePurpose
    }
  , { before: "gracias ", answer: Por, after: " la comida"
    , english: "Thank you for the food.", item: CausePurpose
    }
  , { before: "", answer: Por, after: " eso no vine"
    , english: "That's why I didn't come.", item: CausePurpose
    }
  , { before: "trabajo ", answer: Para, after: " vivir"
    , english: "I work in order to live.", item: CausePurpose
    }
  , { before: "estudio ", answer: Por, after: " la noche"
    , english: "I study at night.", item: DurationDeadline
    }
  , { before: "lo necesito ", answer: Para, after: " mañana"
    , english: "I need it by tomorrow.", item: DurationDeadline
    }
  , { before: "tengo que terminar ", answer: Para, after: " el fin de semana"
    , english: "I have to finish by the weekend.", item: DurationDeadline
    }
  , { before: "lo pensé ", answer: Por, after: " un momento"
    , english: "I thought about it for a moment.", item: DurationDeadline
    }
  , { before: "trabajo ", answer: Por, after: " la mañana"
    , english: "I work in the mornings.", item: DurationDeadline
    }
  , { before: "llego ", answer: Para, after: " la cena"
    , english: "I'll be there in time for dinner.", item: DurationDeadline
    }
  , { before: "caminamos ", answer: Por, after: " la ciudad"
    , english: "We walked around the city.", item: ThroughTowards
    }
  , { before: "salgo ", answer: Para, after: " el hospital"
    , english: "I'm leaving for the hospital.", item: ThroughTowards
    }
  , { before: "vamos ", answer: Para, after: " casa"
    , english: "We're heading home.", item: ThroughTowards
    }
  , { before: "el tren pasa ", answer: Por, after: " el pueblo"
    , english: "The train goes through the town.", item: ThroughTowards
    }
  , { before: "caminaba ", answer: Por, after: " la calle"
    , english: "I was walking down the street.", item: ThroughTowards
    }
  , { before: "el tren sale ", answer: Para, after: " el norte"
    , english: "The train leaves for the north.", item: ThroughTowards
    }
  , { before: "lo vendí ", answer: Por, after: " poco dinero"
    , english: "I sold it for very little money.", item: ExchangeRecipient
    }
  , { before: "este libro es ", answer: Para, after: " mi hermano"
    , english: "This book is for my brother.", item: ExchangeRecipient
    }
  , { before: "hay una carta ", answer: Para, after: " ti"
    , english: "There's a letter for you.", item: ExchangeRecipient
    }
  , { before: "te doy mi libro ", answer: Por, after: " el tuyo"
    , english: "I'll give you my book in exchange for yours.", item: ExchangeRecipient
    }
  , { before: "pago mucho ", answer: Por, after: " esta casa"
    , english: "I pay a lot for this house.", item: ExchangeRecipient
    }
  , { before: "compré comida ", answer: Para, after: " mi madre"
    , english: "I bought my mother some food.", item: ExchangeRecipient
    }
  , { before: "trabajo cinco días ", answer: Por, after: " semana"
    , english: "I work five days a week.", item: Per
    }
  , { before: "llamo a mi madre dos veces ", answer: Por, after: " semana"
    , english: "I call my mother twice a week.", item: Per
    }
  , { before: "nos vemos una vez ", answer: Por, after: " mes"
    , english: "We see each other once a month.", item: Per
    }
  , { before: "hablamos ", answer: Por, after: " teléfono"
    , english: "We talked on the phone.", item: Means
    }
  , { before: "lo escuché ", answer: Por, after: " la radio"
    , english: "I heard it on the radio.", item: Means
    }
  , { before: "lo supe ", answer: Por, after: " mi hermano"
    , english: "I found out through my brother.", item: Means
    }
  ]
